"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var __1 = require("..");

var Button_1 = tslib_1.__importDefault(require("../Buttons/Button"));

var styles = tslib_1.__importStar(require("./ReviewImageUpload.style"));

function ReviewUploadImage(_ref) {
  var onChange = _ref.onChange,
      imageUrl = _ref.imageUrl;

  var _react_1$useState = react_1.useState(Boolean(imageUrl)),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isFulfilled = _react_1$useState2[0],
      setFulfilled = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(false),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      isAlertOpen = _react_1$useState4[0],
      setAlertOpen = _react_1$useState4[1];

  var previewRef = react_1.useRef(null);
  var inputFileRef = react_1.useRef(null);

  function handleImageChange(event) {
    var reader = new FileReader();

    reader.onload = function (e) {
      var _a;

      if (previewRef.current && e.target) {
        previewRef.current.src = ((_a = e.target.result) === null || _a === void 0 ? void 0 : _a.toString()) || '';
      }
    };

    if (event.target && event.target.files) {
      reader.readAsDataURL(event.target.files[0]);
      onChange && onChange(event.target.files[0]);
    }

    setFulfilled(true);
  }

  function handleRemoveButtonClick() {
    setAlertOpen(true);
  }

  function handleRemoveClick() {
    if (inputFileRef.current) {
      inputFileRef.current.value = '';
    }

    setFulfilled(false);
    setAlertOpen(false);
  }

  return jsx_runtime_1.jsxs("div", Object.assign({
    css: styles.container
  }, {
    children: [!isFulfilled ? jsx_runtime_1.jsx("label", Object.assign({
      htmlFor: "mrt-image-upload-input",
      css: styles.labelContainer
    }, {
      children: jsx_runtime_1.jsx("div", Object.assign({
        css: styles.emptyConatiner
      }, {
        children: jsx_runtime_1.jsx("span", Object.assign({
          css: styles.cameraBackCircle
        }, {
          children: jsx_runtime_1.jsx(__1.Icon, {
            name: "ic_camera_md_gray_500",
            alt: "camera"
          }, void 0)
        }), void 0)
      }), void 0)
    }), void 0) : jsx_runtime_1.jsxs("div", Object.assign({
      css: styles.uploadedContainer
    }, {
      children: [jsx_runtime_1.jsx("div", Object.assign({
        css: styles.previewWrapper
      }, {
        children: jsx_runtime_1.jsx("img", {
          ref: previewRef,
          css: styles.previewImage,
          alt: "preview",
          src: imageUrl
        }, void 0)
      }), void 0), jsx_runtime_1.jsxs("div", Object.assign({
        css: styles.optionButtonContainer
      }, {
        children: [jsx_runtime_1.jsx(Button_1.default, Object.assign({
          type: "gray",
          size: "small",
          full: true
        }, {
          children: jsx_runtime_1.jsx("label", Object.assign({
            htmlFor: "mrt-image-upload-input"
          }, {
            children: "\uB2E4\uC2DC \uC62C\uB9AC\uAE30"
          }), void 0)
        }), void 0), jsx_runtime_1.jsxs(Button_1.default, Object.assign({
          type: "gray",
          size: "small",
          onClick: handleRemoveButtonClick,
          full: true
        }, {
          children: [jsx_runtime_1.jsx(__1.Icon, {
            css: styles.trashIcon,
            name: "ic_delete_xs_gray_700"
          }, void 0), "\uC0AD\uC81C\uD558\uAE30"]
        }), void 0)]
      }), void 0)]
    }), void 0), jsx_runtime_1.jsx("input", {
      ref: inputFileRef,
      id: "mrt-image-upload-input",
      css: styles.uploadInput,
      type: "file",
      accept: "image/*",
      onChange: handleImageChange
    }, void 0), jsx_runtime_1.jsx(__1.Alert, Object.assign({
      isOpen: isAlertOpen,
      toggle: setAlertOpen,
      confirmButtonText: "\uC0AD\uC81C\uD558\uAE30",
      cancelButtonText: "\uCDE8\uC18C",
      onConfirmClick: handleRemoveClick
    }, {
      children: "\uB4F1\uB85D\uD55C \uC0AC\uC9C4\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"
    }), void 0)]
  }), void 0);
}

exports.default = ReviewUploadImage;